import {Field, FieldOperations, OpsCategories, SqlOperation, TableI} from "../../Types";
import {nanoid} from "@reduxjs/toolkit";
import {userLevelMap} from "./UsersTable";


const fieldOperations: FieldOperations = {
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
    dt: [...OpsCategories.range],
    msisdn: [...OpsCategories.eq],
    pk_value: [...OpsCategories.eq],
};

export const AuditLogTable: TableI = {
    backend: "/287/",
    title: {
        ua: "Рівні користувачів",
    },
    pk: 'id',
    defaultOrderedBy: "dt",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "dt": {ua: "Час зміни"},
    },
    fieldOperations: fieldOperations,
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№", ru: "№"}, type: "number",
            applyTransform: true
        }, {
            key: "id",
            detailed: true,
            title: {ua: "ID", ru: "№"},
            type: "number",
            applyTransform: true
        },
        {
            key: "pk_value",
            detailed: true,
            title: {ua: "ID поля"},
            type: "string",
            inline: false
        },
        {
            key: "msisdn",
            detailed: true,
            title: {ua: "Телефон"},
            type: "tel",
            applyTransform: true,
            inline: true,
            headAlign: "left",
            searchRef: [
                {
                    table: "users",
                    condition: [{
                        mainField: "msisdn",
                        op: SqlOperation.LIKE
                    }]
                },
            ]
        },
        {
            key: "name",
            detailed: true,
            title: {ua: "П.І.Б"},
            type: "string",
            headAlign: "left",
            inline: true
        },
        {
            key: "old_value",
            detailed: true,
            inline: true,
            title: {ua: "Старе значення"},
            type: "map",
            applyTransform: true,
            map: userLevelMap,
            headAlign: "left"
        },
        {
            key: "new_value",
            detailed: true,
            title: {ua: "Нове значення"},
            type: "map",
            applyTransform: true,
            inline: true,
            headAlign: "left",
            map: userLevelMap
        },
        {
            key: "dt",
            title: {ua: "Час зміни"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            inline: true,
            headAlign: "left",
            detailed: true
        },
    ] as Field[]
}


